import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Contact from "../pages/Contact";
import Home from "../pages/Landing";
import Projects from "../pages/Projects";
import Skills from "../pages/Skills";
export default function index() {
	return (
		<>
			<Router>
				<Switch>
					<Route
						exact
						path="/"
						render={(props) => (
							<Home
								name="Rino Satya Putra"
								work="I'am a junior high school student who works as a full stack website
                                developer. I&nbsp;can work with the team well.I'am currently busy
                                learning new things about technology, especially for websites"
								{...props}
							/>
						)}
					/>
					<Route
						exact
						path="/projects"
						render={(props) => <Projects {...props} />}
					/>
					<Route
						exact
						path="/skills"
						render={(props) => <Skills {...props} />}
					/>
					<Route
						exact
						path="/contact"
						render={(props) => <Contact {...props} />}
					/>
				</Switch>
			</Router>
		</>
	);
}
